import { render, staticRenderFns } from "./BlocTextCreate.vue?vue&type=template&id=a821bd16"
import script from "./BlocTextCreate.vue?vue&type=script&lang=ts"
export * from "./BlocTextCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports